import { Box, Typography, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getFocus, useAtom, useGet } from "state/jotai";
import { active_project, params_query, previousUrl } from "state/store.global";
import { _project } from "state/store.projects";
import { animateScroll } from "react-scroll";
import { Grid } from "components/List/Grid/Grid";
import { useBreak } from "hooks/useBreak";
import "swiper/css/scrollbar";
import { useSnackbar } from "components/ToastMessage/useSnackbar";
import useUnitPage from "components/Unit/useUnitPage";
import StyledButton from "components/Pages/StyledButton";
import { boostrap } from "state/store.fullEido";
import { _bootstrap } from "state/store.bootstrap";
import { useState } from "react";

function RelatedUnits({ relatedUnits }) {
  const isDesktop = useBreak("md_up");
  const eidoData = useGet(boostrap);
  const sitename = useGet(_bootstrap).sitename;
  const { showSnackbar } = useSnackbar();
  const [refContainer] = useUnitPage();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const navigateTo = useNavigate();
  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const params = useGet(params_query);
  const {
    i18n: { language },
  } = useTranslation();
  const [, setPreviousUrl] = useAtom(previousUrl);

  const handleSnackbarOpen = (message) => {
    showSnackbar(message);
  };

  const click1 = (id) => {
    setPreviousUrl(location.pathname);
    navigateTo(`/${language}/unit/${id}${params.length ? params : ""}`);
    if (isDesktop) {
      refContainer?.scrollToTop();
    } else {
      animateScroll.scrollToTop({
        container: refContainer,
        duration: 500,
      });
    }
    log({
      action: "clicked_apartment_on_listview",
      unitId: id,
    });
  };

  const handleClick = () =>
    navigateTo(`/${language}/list${params.length ? params : ""}`);
  const mode = useState("grid");
  const list = {
    handleSnackbarOpen,
    extra: [],
    unitErrMsg: (
      <Box sx={{ textAlign: "center", marginTop: "3rem" }}>
        {eidoData?.labelPropertiesWebsite?.find(
          (btn) => btn.UILabelProperty === "ReletedUnitsNotAvailable"
        )?.Label}
      </Box>
    ),
    click: click1,
    mode: mode[0],
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Heading */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          margin: "0 auto",
          padding: {
            xs: "0 16px",
            sm: "0 24px",
            md: "0 24px",
            lg: "0 80px",
            xl: "0 0px",
          },
        }}
      >
        <Typography
          variant="h4"
          sx={{ mb: 3, fontSize: "1.25rem" }}
          className="h3"
        >
          {eidoData?.labelPropertiesWebsite?.find(
            (btn) => btn.UILabelProperty === "Ledigeboligerihele"
          )?.Label}{" "}
          {sitename}
        </Typography>

        {!relatedUnits.length && (
          <Box sx={{ textAlign: "center", marginTop: "3rem" }}>
            {eidoData?.labelPropertiesWebsite?.find(
              (btn) => btn.UILabelProperty === "ReletedUnitsNotAvailable"
            )?.Label}
          </Box>
        )}
      </Box>

      {/* Slider */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          margin: "0 auto",
          padding: {
            xs: "0 16px",
            sm: "0 24px",
            md: "0 24px",
            lg: "0 80px",
            xl: "0 0px",
          },
        }}
      >
        <Swiper
          modules={[Scrollbar]}
          slidesPerView={isMobile ? 1: "auto"} // 1 full card with a small peek
          centeredSlides={isMobile} // center active slide
          spaceBetween={isMobile ? 15 : 8}
          resistanceRatio={0} // prevent halfway stops
          slideToClickedSlide
          scrollbar={{ draggable: true }}
     
        >
          {relatedUnits?.map((unit, i) => (
            <SwiperSlide
              className="related-units-slider"
              key={i}
              style={{
                scrollSnapAlign: "center",
                width: "fit-content",
                height: "auto",
                borderRadius: "16px",
                overflow: "hidden",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backdropFilter = "blur(6px)";
                e.currentTarget.style.transform = "scale(1.01)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backdropFilter = "none";
                e.currentTarget.style.transform = "none";
              }}
            >
              <Grid {...list} units={[unit]} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* Button */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          margin: "24px auto 0",
          padding: {
            xs: "0 16px",
            sm: "0 24px",
            md: "0 80px",
          },
        }}
      >
        <StyledButton
          Linkto={`/list${params.length ? params : ""}`}
          text={
            buttonsLabel?.find(
              (btn) => btn.UILabelProperty === "SeAlleBoliger"
            )?.Label
          }
          showIcon={false}
        />
      </Box>
    </Box>
  );
}

export default RelatedUnits;
